export const DOCUMENT_TYPE = {
    DriversLicense_Front: 1,
    DriversLicense_Back: 2,
    Passport_Page1: 3,
    Passport_Page2: 4,
    VotersId_Back: 5,
    VotersId_Front: 6,
    Avatar: 7,
    JobLetter: 8,
    Proof_of_Address: 9,
    Proof_of_Income: 10,
    Proof_of_Registration: 11,
    Letter_Of_Undertaking: 12,
    Contracts: 13,
    Certification_Of_Incorporation: 14,
    Tax_Compliance_Certification: 15,
    Invoice: 16,
    Delivery_Slip: 17,
    Gov_ID: 20
};

/*
* State for the contract file
* on document service
*/
export const documentFileKeys = {

    /* The gk representative have appended there signature to the contract document*/
    gkLeaseSigned: 'gk_finance_lease_signed'
};
